// extracted by mini-css-extract-plugin
module.exports = {"SectionPro":"SectionPro_SectionPro__t9Xo_"};